import { RouterModule, Routes } from '@angular/router';

import { BDCPBookmarksRoutes } from '../bookmarks/bookmarks-routing.module';
import { BDCPMasterDetailMasterComponent } from './pages/master/master.page';
import { BDCPProductDetailsRoutes } from '../product-details/product-details-routing.module';
import { BDCPProductFinderRoutes } from '../product-finder/product-finder-routing.module';
import { NgModule } from '@angular/core';

export const BDCPMasterDetailRoutes: Routes = [
    {
        path: '',
        component: BDCPMasterDetailMasterComponent,
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'product-finder'
            },
            {
                path: 'product-finder',
                children: BDCPProductFinderRoutes
            },
            {
                path: 'product-details',
                children: BDCPProductDetailsRoutes
            },
            {
                path: 'bookmarks',
                children: BDCPBookmarksRoutes
            },
            {
                path: '**',
                pathMatch: 'full',
                redirectTo: 'product-finder'
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(BDCPMasterDetailRoutes)],
    exports: [RouterModule]
})
export class BDCPMasterDetailRoutingModule { }
